<!-- please wait screen -->
<div *ngIf="!isCallbackComplete">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="text-center">
          <h1>Please wait...</h1>
          <p>Processing your request</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- success screen -->
<div *ngIf="isCallbackComplete" class="wccard rounded-lg">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="text-center py-8">
          <div class="mb-4">
            <i class="fa-solid fa-puzzle text-webbtree-green fa-5x"></i>
          </div>
          <h1 class="mb-2">Connecting to ATS</h1>
          <p>Please wait while we connect to your ATS</p>
          <p class="mx-auto w-50">
            <!-- infinite prgressbar -->
            <ngb-progressbar type="info" [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
          </p>
          <p class="text-9696">If you are not redirected in 5 seconds, click <a data-testid="auto-app-integration-callback-a-1" href="#" [routerLink]="['/settings/ats-integrations']">here</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
